import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "src/app/core/services/auth.service";
import { DataService } from "src/app/core/services/data.service";
import { HttpClientService } from "src/app/core/services/http-client.service";
import { ModalService } from "src/app/core/services/modal.service";
import { Util } from "src/app/shared/helpers/util";

@Component({
  selector: "app-hom3500",
  templateUrl: "./hom3500.component.html",
  styleUrls: ["./hom3500.component.css"],
})
export class HOM3500Component implements OnInit {
  @Input() modal: any;
  num = 3;
  viewText: any;

  constructor(
    private authService: AuthService,
    private bizServer: HttpClientService,
    private modalService: ModalService,
    private translate: TranslateService,
    private dataService: DataService
  ) {
    this.viewText = this.translate.instant("COMMON");
  }

  ngOnInit() { }

  logout() {
    this.bizServer.httpPost( "signout", { } );
    this.authService.logout();
    this.close();
    this.modalService.alert( {
      btnText: this.translate.instant( 'COMMON.BUTTON.OK' ),
      content: this.viewText.MESSAGE.YOU_HAVE_BEEN_SUCCESSFULLY_LOGGED_OUT_THANK_YOU_FOR_USING_DGB_S_CORPORATE_BANKING_SERVICE,
    } );
  }

  close() {
    this.modal.close();
    this.dataService.scrollMessage("close");
  }
}
